// @ts-nocheck
import React from 'react';
import moment from 'moment';
import { uuid } from 'uuidv4';
import handlebars from 'handlebars';
import get from 'lodash/get';
import { toJS } from 'mobx'; // Global States for faster scheduling

import { useStore } from "../../contexts/store"; // Helpers

import clientEmailTemplateTypeOfNone from "../../helpers/initializeHelpers/emailTemplates/clientEmailTemplateTypeOfNone";
import expertEmailTemplate from "../../helpers/initializeHelpers/emailTemplates/expertEmailTemplate";
import formatExpertInvite from "../../helpers/expertHelpers";
import { formatZoomMeetingId, generateZoomInfo, callRecordedText, extractEmails, isDataValid, isExpertRescheduled, isClientRescheduled, getNewTimeSlot } from "./helpers";
import { getTimezoneName, sendMetric } from '@atheneum/api/dist/lib'; // API

import { scheduleApi } from '@atheneum/api';
import { getExpertLanguage, submitSchedule, translate, scheduleOnCapi, updateCallOnCapi, getEmailTemplateByGroup, getMasterTemplate } from "../../api";
import _ from 'lodash';
handlebars.registerHelper('join', function (array, sep, options) {
  return array.map(function (item) {
    return options.fn(item);
  }).join(sep);
}); // TODO: Move this to environment variable

const MC_KINSEY_PARENT_ACCOUNT_ID = 32; // TODO: availabilityStore and api/emailTemplate/helpers/emailTemplate.helpers.js/getSenderData
// give different data, bug or missing something? Ideally latter should be used (as is the case)
// on backend mails

function getSender(availabilityStore) {
  const {
    user
  } = availabilityStore.userStore;
  const {
    employeePositions
  } = availabilityStore.staticData.names;
  const employeePositionId = user.currentPosition.employeePositionId;
  const userPhones = user.address.phones;
  const phoneNumbers = userPhones.map(phone => phone.phoneNum);
  return {
    phoneNumbers,
    email: user.email,
    fullName: user.fullName,
    phoneNum: phoneNumbers[0],
    positionDescription: employeePositions[employeePositionId] || ''
  };
}

async function wrapExpertMailToMasterTemplate(eplModel, mail, subject, action, availabilityStore) {
  const expertEmail = _.get(eplModel, 'epl.expert.email');

  const {
    masterTemplate,
    unsubscribeText,
    officeAddress
  } = await getMasterTemplate({
    unsubInfoPayload: {
      contactsPayload: {
        email: expertEmail,
        includeExpertId: true
      },
      createPayload: {
        ip: '123',
        employeeId: 0
      }
    }
  });
  const sender = getSender(availabilityStore);
  const updatedSender = Object.assign({}, sender, {
    officeAddress
  });
  const result = handlebars.compile(masterTemplate.content)({
    content: mail,
    emailSubject: subject || masterTemplate.subject,
    includeUnsubscribeLink: true,
    unsubscribeText,
    expert: {
      email: expertEmail
    },
    sender: updatedSender,
    global_url: process.env.LEGACY_PLATFORM_APP_URL
  });
  return result;
}

const Submit = ({
  eplModel,
  growlStore,
  handleClose,
  sendToCalendarService,
  availabilityStore,
  multipleExperts,
  multiAction,
  project // projectStore

}) => {
  const {
    state,
    dispatch
  } = useStore();
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const {
    firstMatch,
    submitFirstMatch,
    schedule,
    readOnly,
    sendZoomUpdate,
    clientinviteEdited,
    quickUpdateExpert,
    quickUpdateClient,
    expertinviteEdited,
    currentPath,
    dayToRender,
    duration,
    zoomTopic,
    allZoomNumbers,
    zoomNum,
    clientSubject,
    clientContacts,
    additionalEmailsExpert,
    additionalEmailsClient,
    skipInviteExpert,
    skipInviteClient,
    expertSubject,
    selectedTeam,
    clientMessage,
    expertMessage,
    takenExpertSlots,
    attachExpertProfilePdf,
    attachExpertScreeningQuestions,
    zoomLocationClient,
    zoomLocationExpert,
    employeeSubmitted,
    selectedLanguage,
    expertsAdded,
    expertInvited,
    clientInvited,
    meetingType,
    expertInfo,
    userPosition,
    clientTitle,
    userPhoneNumbers,
    expertCountry,
    timezoneTranslated,
    languageUpdated,
    templateId,
    previouslySendLanguage,
    connectedZoomMeeting,
    onQuick,
    expertDayOffset,
    locationClient,
    locationExpert,
    expertTimezoneName,
    showExpertCountry,
    sendSmsToPhoneNumberIds,
    expertPhoneNumbers,
    sendSmsExpertPhoneNumber,
    numberOfAdditionalExpertEmail,
    numberOfAdditionalClientEmail,
    numberOfAddedClientEmail,
    templates,
    templateLanguages,
    opsTime,
    onCustom,
    anonymizeClients,
    anonymizeExpert
  } = state;
  const connectedExperts = !!connectedZoomMeeting && !!connectedZoomMeeting.length ? connectedZoomMeeting.filter(meeting => meeting.expertNames.includes(availabilityStore.epl.expert.fullName)).map(meeting => meeting.expertNames.split(', ').filter(experts => !experts.includes(availabilityStore.epl.expert.fullName)))[0] : [];
  const clientsAdded = (numberOfAdditionalClientEmail !== additionalEmailsClient.length || numberOfAddedClientEmail !== clientContacts.length) && clientInvited;
  const expertAdditionalsAdded = numberOfAdditionalExpertEmail !== additionalEmailsExpert.length && expertInvited;
  const rescheduleExpert = isExpertRescheduled({
    currentPath,
    readOnly,
    schedule,
    dayToRender,
    duration,
    availabilityStore,
    quickUpdateExpert,
    expertinviteEdited,
    expertInvited,
    expertAdditionalsAdded,
    opsTime
  });
  const rescheduleClient = isClientRescheduled({
    currentPath,
    readOnly,
    schedule,
    dayToRender,
    duration,
    availabilityStore,
    quickUpdateClient,
    clientinviteEdited,
    clientInvited,
    clientsAdded,
    opsTime
  });

  const updateZoomMeeting = async (data, zoomMeetingId) => {
    try {
      await scheduleApi.saveZoomMeeting(data.schedule.id, {
        zoomMeetingId: zoomMeetingId,
        duration: data.schedule.duration || availabilityStore.schedule.duration,
        password: availabilityStore.epl.id,
        startTime: data.schedule.startTime,
        topic: zoomTopic,
        participants: {
          clients: clientContacts,
          expert: data.epl.expert,
          anonymizeClients,
          anonymizeExpert,
          selectedLanguage
        }
      });
      growlStore.showSuccess('Zoom meeting created');
      sendMetric('scheduling.ZoomCreation', 'scheduling', {
        status: 'success'
      });
    } catch (error) {
      console.error(error);
    }
  };

  const sendQuickNoInvites = async data => {
    const zoomMeetingId = availabilityStore.schedule ? availabilityStore.schedule.zoomMeetingId : null;
    await updateZoomMeeting(data, zoomMeetingId);
  };

  const inviteClient = async (data, skipZoomMeeting, updatedClientMail) => {
    try {
      if (!skipZoomMeeting) {
        await updateZoomMeeting(data, availabilityStore.zoomMeetingId);
      }

      await availabilityStore.init();
      const updateLocationClient = zoomLocationClient.includes('{{{meetingId}}}') ? zoomLocationClient.replace('{{{meetingId}}}', `${formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId)}#`) : zoomLocationClient;
      const inviteTemplate = handlebars.compile(clientMessage);
      let result = await generateZoomInfo({
        staticData: availabilityStore.staticData,
        schedule: availabilityStore.schedule,
        password: availabilityStore.epl.id,
        clientContacts,
        allZoomNumbers
      });
      result = callRecordedText({
        schedule: availabilityStore.schedule
      });
      const messageClient = !!updatedClientMail ? updatedClientMail : inviteTemplate({
        generateZoomInfo: await generateZoomInfo({
          staticData: availabilityStore.staticData,
          schedule: availabilityStore.schedule,
          password: availabilityStore.epl.id,
          clientContacts,
          allZoomNumbers
        }),
        callRecordedText: callRecordedText({
          schedule: availabilityStore.schedule
        }),
        // NOTE: we do more templating on the backend
        screeningQuestions: '{{{screeningQuestions}}}',
        expertPdfAttachment: '{{{expertPdfAttachment}}}',
        additionalText: '{{{additionalText}}}'
      });

      if (!availabilityStore.schedule) {
        growlStore.showError('Zoom call, Client Invite sending failed.', 'Please create a ticket with the EPL details and incident time.');
        sendMetric('Zoom.fail', 'notify-clients', {
          status: 'failed'
        });
        return;
      }

      try {
        await scheduleApi.notifyClients(availabilityStore.schedule.id, {
          team: selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.value,
          message: messageClient,
          subject: clientSubject,
          location: meetingType !== 'Zoom' ? locationClient : updateLocationClient,
          startTime: availabilityStore.schedule.startTime,
          endTime: availabilityStore.schedule.endTime,
          contacts: clientContacts,
          additionalEmails: extractEmails(additionalEmailsClient),
          timezoneName: getTimezoneName(),
          skipInvite: skipInviteClient,
          attachExpertProfilePdf,
          attachExpertScreeningQuestions
        });
        sendMetric('Outlook.send', 'notify-client', {
          sendTo: 'client',
          status: 'success'
        });
        growlStore.showSuccess('Zoom invite for Client sent');
      } catch (error) {
        console.error(error);
        growlStore.showError('Notify Clients failed.', 'Please create a ticket with the EPL details and incident time.');
        sendMetric('Outlook.fail', 'notify-clients', {
          user: availabilityStore.userStore.user.id,
          status: 'failed'
        });
      }
    } catch (error) {
      console.error(error);
      growlStore.showError('Zoom call, Client Invite sending failed.', 'Please create a ticket with the EPL details and incident time.');
      sendMetric('Zoom.fail', 'notify-clients', {
        status: 'failed'
      });
    }
  };

  const inviteExpert = async (data, skipZoomMeeting = false) => {
    try {
      if (!skipZoomMeeting) {
        await updateZoomMeeting(data, availabilityStore.zoomMeetingId);
      }

      await availabilityStore.init();
      const updateLocationExpert = zoomLocationExpert.includes('{{{meetingId}}}') ? zoomLocationExpert.replace('{{{meetingId}}}', `${formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId)}#`) : zoomLocationExpert;
      const messageToExpert = formatExpertInvite(expertMessage, schedule, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry);

      if (!availabilityStore.schedule) {
        growlStore.showError('Zoom call, Expert Invite sending failed', 'Please create a ticket with the EPL details and incident time.');
        sendMetric('Zoom.fail', 'notify-experts', {
          status: 'failed'
        });
        return;
      }

      try {
        await scheduleApi.notifyExpert(availabilityStore.schedule.id, {
          message: messageToExpert,
          subject: expertSubject,
          location: meetingType !== 'Zoom' ? locationExpert : updateLocationExpert,
          team: selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.value,
          startTime: availabilityStore.schedule.startTime,
          endTime: availabilityStore.schedule.endTime,
          contacts: [availabilityStore.epl.expert],
          additionalEmails: extractEmails(additionalEmailsExpert),
          timezoneName: getTimezoneName(),
          skipInvite: skipInviteExpert,
          attachments: eplModel.details ? Array.from(eplModel.details.attachments) : [],
          selectedLanguage
        });
        sendMetric('Outlook.send', 'notify-expert', {
          sendTo: 'expert',
          status: 'success'
        });
        growlStore.showSuccess('Zoom invite for Expert send');
      } catch (error) {
        sendMetric('Outlook.fail', 'notify-expert', {
          user: availabilityStore.userStore.user.id,
          status: 'failed'
        });
        throw error;
      }
    } catch (error) {
      console.error(error);
      growlStore.showError('Zoom call, Expert Invite sending failed', 'Please create a ticket with the EPL details and incident time.');
      sendMetric('Zoom.fail', 'notify-experts', {
        status: 'failed'
      });
    }
  };

  const inviteExpertAndClient = async (data, skipZoomMeeting) => {
    await inviteExpert(data, skipZoomMeeting);
    await inviteClient(data, skipZoomMeeting, null);
  };

  const updatedClientMail = () => {
    const expertArr = !!clientMessage.split('call scheduled with')[1] && clientMessage.split('call scheduled with')[1].includes('<ul id="expertList-target-fs">') ? [...expertsAdded] : [...expertsAdded, availabilityStore];
    const addedExperts = expertArr.map(expert => {
      const expertPosition = get(expert.epl, 'relevantExperience.experience.position.name', '');
      const expertCompany = get(expert.epl, 'relevantExperience.experience.company.name', '');
      const expertLocation = get(expert.epl, 'relevantExperience.experience.location', '');
      const relevantSegment = get(expert.epl, 'segment.name', '');
      const {
        nameDisclosed
      } = expert.epl;
      const title = nameDisclosed ? `${expert.epl.expert.title} ${expert.epl.expert.fullName || 'Expert'}` : 'Expert';
      return `<li>${title}, ${expertPosition}, ${expertCompany}, ${expertLocation} for Segment: ${relevantSegment}</li>`;
    }).join('');
    const expertList = `<ul id="expertList-target-fs">${addedExperts}</ul>`;

    if (!!clientMessage.split('call scheduled with')[1] && clientMessage.split('call scheduled with')[1].includes('<ul id="expertList-target-fs">')) {
      // Already a list of experts
      const scheduledExperts = clientMessage.split('<ul id="expertList-target-fs">')[1].split('</ul>')[0].concat(addedExperts);
      return clientMessage.replace(clientMessage.split('<ul id="expertList-target-fs">')[1].split('</ul>')[0], scheduledExperts);
    } else if (clientMessage.split('call scheduled with')[1]) {
      return clientMessage.replace(clientMessage.split('call scheduled with')[1].split('</p>')[0], expertList);
    } else {
      return clientMessage;
    }
  };

  const getExpertPhoneNumberIds = expert => {
    var _expert$epl, _expert$epl$phoneToAd, _expert$epl$phoneToAd2, _expert$epl2, _expert$epl2$expert, _expert$epl2$expert$e, _expert$epl3, _expert$epl4, _expert$epl4$expert, _expert$epl4$expert$a, _expert$epl4$expert$a2;

    //is "!!" necessary here?
    if (!!(expert !== null && expert !== void 0 && (_expert$epl = expert.epl) !== null && _expert$epl !== void 0 && (_expert$epl$phoneToAd = _expert$epl.phoneToAddressEpls) !== null && _expert$epl$phoneToAd !== void 0 && (_expert$epl$phoneToAd2 = _expert$epl$phoneToAd.filter(x => !!x)) !== null && _expert$epl$phoneToAd2 !== void 0 && _expert$epl$phoneToAd2.length)) {
      return expert.epl.phoneToAddressEpls.map(({
        id
      }) => id);
    } else if ((expert !== null && expert !== void 0 && (_expert$epl2 = expert.epl) !== null && _expert$epl2 !== void 0 && (_expert$epl2$expert = _expert$epl2.expert) !== null && _expert$epl2$expert !== void 0 && (_expert$epl2$expert$e = _expert$epl2$expert.expert) !== null && _expert$epl2$expert$e !== void 0 && _expert$epl2$expert$e.sendSmsReminders || expert !== null && expert !== void 0 && (_expert$epl3 = expert.epl) !== null && _expert$epl3 !== void 0 && _expert$epl3.sendSmsExpertPhoneNumber) && expert !== null && expert !== void 0 && (_expert$epl4 = expert.epl) !== null && _expert$epl4 !== void 0 && (_expert$epl4$expert = _expert$epl4.expert) !== null && _expert$epl4$expert !== void 0 && (_expert$epl4$expert$a = _expert$epl4$expert.address) !== null && _expert$epl4$expert$a !== void 0 && (_expert$epl4$expert$a2 = _expert$epl4$expert$a.phones) !== null && _expert$epl4$expert$a2 !== void 0 && _expert$epl4$expert$a2[0]) {
      return [expert.epl.expert.address.phones[0].id];
    }

    return [];
  };

  const inviteAdditionalExpert = async ({
    newExpert
  }) => {
    const nupdatedTimeSlot = {
      time: {
        start: new Date(availabilityStore.schedule.startTime).getTime(),
        end: new Date(availabilityStore.schedule.endTime).getTime()
      }
    };

    try {
      const sendSmsToPhoneNumberIds = getExpertPhoneNumberIds(newExpert);
      const data = await submitSchedule({
        availabilities: [],
        drafts: [],
        timeslots: [nupdatedTimeSlot],
        eplId: newExpert.epl.id,
        lockInterviewDuration: false,
        sendSmsToPhoneNumberIds,
        expertPhoneNumbers: [],
        sendSmsExpertPhoneNumber: newExpert.epl.sendSmsExpertPhoneNumber,
        participants: {
          clients: clientContacts,
          expert: availabilityStore.epl.expert,
          anonymizeClients,
          anonymizeExpert,
          selectedLanguage
        }
      });
      await scheduleApi.attachZoomMeeting(data.schedule.id, availabilityStore.schedule.id);
      await updateZoomMeeting(data, null);
      const expert = await getExpertLanguage(newExpert.epl.expert.id);
      const languagesFiltered = expert.data.languages.map(d => d.name).filter(lang => templateLanguages.includes(lang.split(' ')[0]));
      const language = languagesFiltered.length ? languagesFiltered[0].split(' ')[0] : 'english';
      const isEnglish = language.toLowerCase() === 'english';
      const languages = {
        chinese: 'zhTW',
        spanish: 'es',
        russian: 'ru',
        german: 'de',
        french: 'fr',
        italian: 'it',
        korean: 'ko',
        portuguese: 'pt',
        english: 'en',
        polish: 'pl',
        japanese: 'ja'
      }; // Note: is it possible that expert.data.address is undefined?

      const countryName = availabilityStore.staticData.names.countries[expert.data.address.countryId];
      const timezoneName = availabilityStore.staticData.names.timezones[expert.data.address.timezoneId];
      let country;
      let timezone;

      if (!isEnglish) {
        const {
          data: translatedCountry
        } = await translate(countryName, languages[language.toLowerCase()]);
        country = translatedCountry.TranslatedText;
        const {
          data: translatedTimezone
        } = await translate(timezoneName, languages[language.toLowerCase()]);
        timezone = translatedTimezone.TranslatedText;
      } else {
        country = countryName;
        timezone = timezoneName;
      }

      const expertTemplate = templates.filter(template => template.name.toLowerCase() === language.toLowerCase())[0];

      const getCountryId = (data, countryId) => {
        const address = data.find(el => el.countryId === countryId);
        const result = !!address && !!address.internationalNumbers && !!address.internationalNumbers.length || !!address && !!address.tollFreeNumbers && !!address.tollFreeNumbers.length ? countryId : 219;
        return result;
      };

      let expertZoomNum;
      const zoomData = await scheduleApi.getZoomNumbers(); // Note: if newExpert.epl.expert.address is undefined, this can fail

      const expertId = getCountryId(zoomData, newExpert.epl.expert.address.countryId);
      const getCountryNumberExpert = zoomData.filter(data => data.countryId === expertId);
      expertZoomNum = getCountryNumberExpert;
      const newSchedule = {
        timeslots: currentPath === 'overview' ? schedule.timeslots : [getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration)]
      };
      const newExpertId = newExpert.epl.id;
      newExpert.epl.id = availabilityStore.epl.id;

      try {
        const updateLocationExpert = zoomLocationExpert.includes('{{{meetingId}}}') ? zoomLocationExpert.replace('{{{meetingId}}}', `${formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId)}#`) : zoomLocationExpert;
        const messageToExpert = formatExpertInvite(expertTemplate.content, newSchedule, newExpert, expertZoomNum, employeeSubmitted, language, country, timezoneName, timezone, languageUpdated, expertTemplate.id, previouslySendLanguage, expertDayOffset, showExpertCountry).replaceAll('MEETINGID', availabilityStore.schedule.zoomMeetingId).replace('https://atheneum-partners.zoom.us//', availabilityStore.schedule.zoomJoinUrl);

        if (!availabilityStore.schedule) {
          growlStore.showError('Zoom call, Expert Invite sending failed', 'Please create a ticket with the EPL details and incident time.');
          sendMetric('Zoom.fail', 'notify-experts', {
            status: 'failed'
          });
          return;
        }

        await scheduleApi.notifyExpert(data.schedule.id, {
          message: messageToExpert,
          subject: expertSubject,
          location: meetingType !== 'Zoom' ? locationExpert : updateLocationExpert,
          team: selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.value,
          startTime: data.schedule.startTime,
          endTime: data.schedule.endTime,
          contacts: [newExpert.epl.expert],
          additionalEmails: Array.from(additionalEmailsExpert).map(({
            email
          }) => ({
            email
          })),
          timezoneName: timezoneName,
          skipInvite: false,
          attachments: [],
          selectedLanguage
        });
        sendMetric('Outlook.send', 'notify-expert', {
          sendTo: 'expert',
          status: 'success'
        });
      } catch (error) {
        console.error(error);
        sendMetric('Outlook.fail', 'notify-expert', {
          user: availabilityStore.userStore.user.id,
          status: 'failed'
        });
        growlStore.showError('Zoom call, Expert Invite sending failed', 'Please create a ticket with the EPL details and incident time.');
      }

      newExpert.epl.id = newExpertId;
      await newExpert.get();
    } catch (error) {
      return console.error(error);
    }
  };

  const sendDataToCapi = async ({
    isMckinseyMeeting,
    expertId,
    segmentId,
    eplId
  }) => {
    // REVIEW: firstMatch and newTimeslots have different types,
    // firstMatch is timestamp (number)
    // newTimeSlot is a iso string.
    const startTime = new Date(currentPath === 'overview' ? firstMatch : getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration).time.start);

    if (startTime.getTime() < new Date().getTime() + 5 * 60 * 1000) {
      growlStore.showError('McKinsey Interviews need to be scheduled at 5 mins ahead of time', 'ERROR!');
      return false;
    }

    try {
      await scheduleOnCapi({
        expertId,
        segmentId,
        startTime: startTime.toISOString(),
        duration,
        eplId: eplId,
        callType: meetingType
      });

      if (isMckinseyMeeting) {
        growlStore.showSuccess('Scheduled McKinsey API meeting...');
      }
    } catch (error) {
      console.error(error); //REVIEW: mckinsey meetings are scheduled via ens api so if they fail the call
      // isn't actually scheduled, the rest are just to keep capi in sync with platform but not critical

      if (isMckinseyMeeting) {
        var _error$response;

        growlStore.showError((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data);
        handleClose();
        return false;
      }
    }

    return true;
  };

  const closingActions = async (client, expert, data) => {
    if (!client && expert) {
      await availabilityStore.init();
      await inviteExpert(data);
      eplModel.get().then(() => handleClose());
    } else if (client && !expert) {
      await availabilityStore.init();
      await inviteClient(data, null, null);
      eplModel.get().then(() => handleClose());
    } else if (client && expert) {
      await availabilityStore.init();
      await inviteExpertAndClient(data, null);
      eplModel.get().then(() => handleClose());
    } else if (sendZoomUpdate) {
      await availabilityStore.init();
      await sendQuickNoInvites(data);
      eplModel.get().then(() => handleClose());
    } else eplModel.get().then(() => handleClose());
  }; //MEM


  const updateScheduleAndNotifyForMultipleExpert = async () => {
    growlStore.showSuccess('Schedule Updated');
    sendMetric('scheduling.Updated', 'scheduling', {
      status: 'success'
    }); // reschedule parent

    const data = await submitSchedule({
      availabilities: [],
      drafts: [],
      timeslots: [getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration)],
      eplId: availabilityStore.epl.id,
      lockInterviewDuration: false,
      sendSmsToPhoneNumberIds,
      expertPhoneNumbers,
      sendSmsExpertPhoneNumber,
      message: {
        subjectExpert: '',
        subjectClient: '',
        expertEmail: '',
        clientMail: ''
      },
      attachExpertProfilePdf,
      attachExpertScreeningQuestions,
      contacts: clientContacts,
      participants: {
        clients: clientContacts,
        expert: availabilityStore.epl.expert,
        anonymizeClients,
        anonymizeExpert,
        selectedLanguage
      }
    });
    await updateZoomMeeting(data, availabilityStore.schedule.zoomMeetingId);
    await availabilityStore.init();

    if (!!clientInvited) {
      const inviteTemplate = handlebars.compile(clientMessage);
      const reg1 = /\d{3}-\d{3}-\d{3}-\d{2}#/;
      const reg2 = /\d{11}#/g;
      const messageClient = inviteTemplate({
        generateZoomInfo: await generateZoomInfo({
          staticData: availabilityStore.staticData,
          schedule: data.schedule,
          password: availabilityStore.epl.id,
          clientContacts,
          allZoomNumbers
        }),
        callRecordedText: callRecordedText({
          schedule: availabilityStore.schedule
        }),
        // NOTE: we do more templating on the backend
        screeningQuestions: '{{{screeningQuestions}}}',
        expertPdfAttachment: '{{{expertPdfAttachment}}}',
        additionalText: '{{{additionalText}}}'
      }).replace(reg1, `${formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId)}#`).replaceAll(reg2, `${availabilityStore.schedule.zoomMeetingId}#`);
      const updateLocationClient = zoomLocationClient.includes('{{{meetingId}}}') ? zoomLocationClient.replace('{{{meetingId}}}', `${formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId)}#`) : zoomLocationClient;

      if (!availabilityStore.schedule) {
        growlStore.showError('Zoom call, Client Invite sending failed.', 'Please create a ticket with the EPL details and incident time.');
        sendMetric('Zoom.fail', 'notify-clients', {
          status: 'failed'
        });
        return;
      }

      try {
        await scheduleApi.notifyClients(availabilityStore.schedule.id, {
          team: selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.value,
          message: messageClient,
          subject: clientSubject,
          location: updateLocationClient,
          startTime: availabilityStore.schedule.startTime,
          endTime: availabilityStore.schedule.endTime,
          contacts: clientContacts,
          additionalEmails: Array.from(additionalEmailsClient).map(({
            email
          }) => ({
            email
          })),
          timezoneName: getTimezoneName(),
          skipInvite: skipInviteClient,
          attachExpertProfilePdf,
          attachExpertScreeningQuestions
        });
        sendMetric('Outlook.send', 'notify-expert', {
          sendTo: 'expert',
          status: 'success'
        });
      } catch (error) {
        sendMetric('Outlook.fail', 'notify-expert', {
          user: availabilityStore.userStore.user.id,
          status: 'failed'
        });
        growlStore.showError('Notify Clients failed.', 'Please create a ticket with the EPL details and incident time.');
      }
    }

    if (!!expertInvited) {
      const newSchedule = {
        timeslots: [getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration)]
      };
      const response = await expertEmailTemplate(selectedLanguage.toLowerCase(), availabilityStore.epl.honorarium);
      const updateLocationExpert = zoomLocationExpert.includes('{{{meetingId}}}') ? zoomLocationExpert.replace('{{{meetingId}}}', `${formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId)}#`) : zoomLocationExpert;
      const messageExpert = formatExpertInvite(response.expertMessage, newSchedule, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry).replaceAll('MEETINGID#', `${availabilityStore.schedule.zoomMeetingId}#`).replaceAll('MEETINGID', `${formatZoomMeetingId(availabilityStore.schedule.zoomMeetingId)}#`).replace('https://atheneum-partners.zoom.us//', availabilityStore.schedule.zoomJoinUrl);

      if (!availabilityStore.schedule) {
        growlStore.showError('Zoom call, Expert Invite sending failed', 'Please create a ticket with the EPL details and incident time.');
        sendMetric('Zoom.fail', 'notify-experts', {
          status: 'failed'
        });
        return;
      }

      try {
        await scheduleApi.notifyExpert(availabilityStore.schedule.id, {
          message: await wrapExpertMailToMasterTemplate(eplModel, messageExpert, expertSubject, 'updateScheduleAndNotifyForMultipleExpert', availabilityStore),
          subject: expertSubject,
          location: meetingType !== 'Zoom' ? locationExpert : updateLocationExpert,
          team: selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.value,
          startTime: availabilityStore.schedule.startTime,
          endTime: availabilityStore.schedule.endTime,
          contacts: [availabilityStore.epl.expert],
          additionalEmails: Array.from(additionalEmailsExpert).map(({
            email
          }) => ({
            email
          })),
          timezoneName: getTimezoneName(),
          skipInvite: skipInviteExpert,
          attachments: eplModel.details ? Array.from(eplModel.details.attachments) : [],
          selectedLanguage
        });
        sendMetric('Outlook.send', 'notify-expert', {
          sendTo: 'expert',
          status: 'success'
        });
      } catch (error) {
        sendMetric('Outlook.fail', 'notify-expert', {
          user: availabilityStore.userStore.user.id,
          status: 'failed'
        });
        growlStore.showError('Zoom call, Expert Invite sending failed', 'Please create a ticket with the EPL details and incident time.');
      }
    }

    const additionalExperts = multipleExperts.filter(x => x.epl.id !== availabilityStore.epl.id);
    const invitePromises = additionalExperts.map(expert => inviteAdditionalExpert({
      newExpert: expert
    }, true));
    await Promise.all(invitePromises);
  };

  const updateExpertMessage = async newSchedule => {
    // Only update expert message when start time has changed and it's not using the 'quick' feature
    if (!!availabilityStore.schedule && new Date(availabilityStore.schedule.startTime).getTime() !== getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration).time.start && !onQuick) {
      const formattedExpertInvite = formatExpertInvite(expertMessage, newSchedule, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry);
      dispatch({
        type: 'UPDATE',
        payload: {
          expertMessage: await wrapExpertMailToMasterTemplate(eplModel, formattedExpertInvite, expertSubject, 'updateExpertMessage', availabilityStore)
        }
      });
    }
  };

  const getSubmittedSchedule = async ({
    newSchedule,
    newTimeSlots
  }) => {
    let timeslots = currentPath === 'overview' ? schedule.timeslots : [getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration)];

    if (newTimeSlots) {
      timeslots = newTimeSlots;
    }

    const formattedExpertInvite = formatExpertInvite(expertMessage, newSchedule, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry);
    return submitSchedule({
      availabilities: schedule.availabilities,
      drafts: [],
      timeslots,
      eplId: availabilityStore.epl.id,
      lockInterviewDuration: false,
      sendSmsToPhoneNumberIds,
      expertPhoneNumbers,
      sendSmsExpertPhoneNumber,
      message: {
        subjectExpert: rescheduleExpert ? expertSubject : '',
        subjectClient: rescheduleClient ? clientSubject : '',
        expertEmail: rescheduleExpert ? await wrapExpertMailToMasterTemplate(eplModel, formattedExpertInvite, expertSubject, 'getSubmittedSchedule', availabilityStore) : '',
        clientMail: rescheduleClient ? clientMessage : ''
      },
      attachExpertProfilePdf,
      attachExpertScreeningQuestions,
      contacts: clientContacts,
      participants: {
        clients: clientContacts,
        expert: availabilityStore.epl.expert,
        anonymizeClients,
        anonymizeExpert,
        selectedLanguage
      }
    });
  };

  const dataIsNotValid = () => {
    return !isDataValid({
      currentPath,
      readOnly,
      schedule,
      dayToRender,
      duration,
      availabilityStore,
      quickUpdateExpert,
      expertinviteEdited,
      quickUpdateClient,
      clientinviteEdited,
      expertsAdded,
      growlStore,
      clientContacts,
      multiAction,
      connectedExperts,
      takenExpertSlots,
      opsTime,
      selectedTeam,
      onQuick,
      onCustom
    });
  };

  const prepareMessageAndSendToExpert = async data => {
    let newTemplate = expertMessage;

    if (expertMessage.includes('MEETINGID')) {
      const responseTemplates = await getEmailTemplateByGroup('schedule_invite_no_honorarium_free');
      newTemplate = responseTemplates.filter(d => d.name.toLowerCase().includes(selectedLanguage))[0].content;
    }

    try {
      const messageToExpert = formatExpertInvite(newTemplate, schedule, availabilityStore, zoomNum, employeeSubmitted, selectedLanguage, expertCountry, expertTimezoneName, timezoneTranslated, languageUpdated, templateId, previouslySendLanguage, expertDayOffset, showExpertCountry);

      if (!data.schedule) {
        growlStore.showError('Zoom call, Expert Invite sending failed', 'Please create a ticket with the EPL details and incident time.');
        sendMetric('Zoom.fail', 'notify-experts', {
          status: 'failed'
        });
        return;
      }

      await scheduleApi.notifyExpert(data.schedule.id, {
        message: messageToExpert,
        subject: expertSubject,
        location: locationExpert,
        team: selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.value,
        startTime: data.schedule.startTime,
        endTime: data.schedule.endTime,
        contacts: [availabilityStore.epl.expert],
        additionalEmails: Array.from(additionalEmailsExpert).map(({
          email
        }) => ({
          email
        })),
        timezoneName: moment.tz().zoneName(),
        skipInvite: skipInviteExpert,
        attachments: availabilityStore.details ? Array.from(availabilityStore.details.attachments) : [],
        selectedLanguage
      });
      sendMetric('Outlook.send', 'notify-expert', {
        sendTo: 'expert',
        status: 'success'
      });
    } catch (error) {
      sendMetric('Outlook.fail', 'notify-expert', {
        user: availabilityStore.userStore.user.id,
        status: 'failed'
      });
      growlStore.showError('Zoom call, Expert Invite sending failed', 'Please create a ticket with the EPL details and incident time.');
    }
  };

  const prepareMessageAndNotifyClient = async data => {
    try {
      await scheduleApi.notifyClients(data.schedule.id, {
        team: selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.value,
        message: clientMessage.includes('https://atheneum-partners.zoom.us/u/') ? clientEmailTemplateTypeOfNone(clientTitle, expertInfo, availabilityStore, userPosition, userPhoneNumbers) : clientMessage,
        subject: clientSubject,
        location: locationClient,
        startTime: data.schedule.startTime,
        endTime: data.schedule.endTime,
        contacts: clientContacts,
        additionalEmails: Array.from(additionalEmailsClient).map(({
          email
        }) => ({
          email
        })),
        timezoneName: getTimezoneName(),
        skipInvite: skipInviteClient,
        attachExpertProfilePdf,
        attachExpertScreeningQuestions
      });
      growlStore.showSuccess('Invite for Client send');
    } catch (error) {
      growlStore.showError('Notify Clients failed.', 'Please create a ticket with the EPL details and incident time.');
      throw error;
    }
  };

  const updateCallForCapi = async (data, capiProjectType, expertId, segmentId, id) => {
    const scheduleId = data.schedule.id;

    if (project.parentAccountId === MC_KINSEY_PARENT_ACCOUNT_ID && capiProjectType) {
      const updateData = {
        expertId,
        segmentId,
        scheduleId,
        eplId: id,
        callType: meetingType
      };

      try {
        await updateCallOnCapi(updateData);
        growlStore.showSuccess('Updating McKinsey API meeting schedule...');
      } catch (error) {
        growlStore.showError('Failed to update call status to scheduled on CAPI service');
      }
    }

    growlStore.showSuccess('Schedule Updated');
  };

  const handleExpertsAdded = async () => {
    dispatch({
      type: 'UPDATE',
      payload: {
        renderSpinner: true
      }
    });
    growlStore.showSuccess('Scheduling added Expert(s)...');
    const haveZoomMeeting = availabilityStore.persistedScheduleInfo && !!availabilityStore.persistedScheduleInfo.zoomMeetingId && !!availabilityStore.persistedScheduleInfo.zoomMeeting;
    let client = quickUpdateClient || clientinviteEdited === 'client' || !!availabilityStore.schedule && !!availabilityStore.schedule.clientInvitationSentDate || clientsAdded || clientInvited; // to have mobx observable accessible

    const plainAvailabilityStore = toJS(availabilityStore);

    try {
      if (!haveZoomMeeting) {
        await updateZoomMeeting(plainAvailabilityStore, null);
      } else {
        client = quickUpdateClient || clientinviteEdited === 'client' || clientsAdded || clientInvited;
      }

      if (!!client) {
        await inviteClient({
          data: {
            schedule: {
              startTime: plainAvailabilityStore.schedule.startTime,
              duration: plainAvailabilityStore.schedule.duration,
              id: plainAvailabilityStore.schedule.id
            }
          }
        }, true, updatedClientMail());
      }

      const invitePromises = expertsAdded.map(expert => inviteAdditionalExpert({
        newExpert: expert
      }, false));
      await Promise.all(invitePromises);
    } catch (error) {
      console.error(error);
    } finally {
      return eplModel.get().then(() => handleClose());
    }
  };

  const isSlotAvailable = () => {
    const startTimes = takenExpertSlots.map(slot => parseInt(moment(slot.startTime).format('x')));
    const endTimes = takenExpertSlots.map(slot => parseInt(moment(slot.endTime).format('x')));
    const start = parseInt(firstMatch);
    const end = parseInt(firstMatch + 1000 * duration);
    const startTimeCheck = startTimes.every(startTime => {
      return start <= startTime && end > startTime;
    });
    const endTimesCheck = endTimes.every(endTime => {
      return start < endTime && end >= endTime;
    });
    const freeSlot = !startTimeCheck && !endTimesCheck;

    if (takenExpertSlots.length && !freeSlot) {
      growlStore.showError('Slot is already taken for this expert.');
      sendMetric('scheduling.SlotTaken', 'scheduling', {
        status: 'error'
      });
      return false;
    }

    if (schedule.timeslots.length) {
      if (schedule.timeslots[0].time.start < new Date().getTime()) {
        growlStore.showWarning('Cannot Submit a Timeslot in the past');
        sendMetric('scheduling.PastTimeslot', 'scheduling', {
          status: 'warning'
        });
        return false;
      }
    }

    if (!schedule.timeslots.length || !submitFirstMatch) {
      growlStore.showWarning('No timeslot was selected');
      sendMetric('scheduling.NoTimeslotSelected', 'scheduling', {
        status: 'error'
      });
      return false;
    }

    return true;
  };

  const executeActions = async () => {
    // variables start
    const isSchedulingMode = readOnly;
    const {
      expertId,
      segmentId,
      id: eplId
    } = availabilityStore.epl;
    const {
      projectSource
    } = project;
    const isMckinseyMeeting = meetingType === 'mcKinsey';
    const newSchedule = {
      timeslots: currentPath === 'overview' ? schedule.timeslots : [getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration)]
    }; // variables end

    if (!isSchedulingMode) {
      // When it is calendar view and is availability mode, adds availability
      if (meetingType === 'None' || isMckinseyMeeting || currentPath === 'calendarview') {
        dispatch({
          type: 'UPDATE',
          payload: {
            renderSpinner: true
          }
        });
        sendMetric('scheduling.availabilitiesAdded', 'scheduling', {
          version: 'new'
        });
        sendToCalendarService(schedule);
        return eplModel.get().then(() => {
          handleClose();
        });
      }
    } // When it's mckinsey project


    if (project.parentAccountId === MC_KINSEY_PARENT_ACCOUNT_ID && projectSource === 'capi-mckinsey') {
      const sendToCapiSuccessful = await sendDataToCapi({
        isMckinseyMeeting,
        expertId,
        segmentId,
        eplId
      }); // Exit function if send data to capi failed

      if (!sendToCapiSuccessful) return;
    } // When it's none meeting type for mckinsey, submit schedule and send notification and exit


    if (meetingType === 'None' || isMckinseyMeeting) {
      dispatch({
        type: 'UPDATE',
        payload: {
          renderSpinner: true
        }
      });
      const client = quickUpdateClient || clientinviteEdited === 'client' || !!availabilityStore.schedule && !!availabilityStore.schedule.clientInvitationSentDate;
      const expert = quickUpdateExpert || expertinviteEdited === 'expert' || !!availabilityStore.schedule && !!availabilityStore.schedule.expertInvitationSentDate;
      growlStore.showSuccess('Updating schedule...'); // Do we need this?

      await updateExpertMessage(newSchedule);

      try {
        const data = await getSubmittedSchedule({
          newSchedule,
          newTimeSlots: null
        });
        const {
          expertId,
          segmentId,
          id
        } = availabilityStore.epl; // Update call on capi if we have schedule from response and it's mckinseyMeeting

        const {
          capiProjectType
        } = project;

        if (data.schedule && isMckinseyMeeting) {
          await updateCallForCapi(data, capiProjectType, expertId, segmentId, id);
          return;
        }

        growlStore.showSuccess('Schedule Updated');
        sendMetric('scheduling.Updated', 'scheduling', {
          status: 'success'
        });
        const prData = data;

        if (expert && !expertInvited || expertAdditionalsAdded) {
          await prepareMessageAndSendToExpert(prData);
        }

        if (client && !clientInvited || clientsAdded) {
          await prepareMessageAndNotifyClient(prData);
        }
      } catch (error) {
        console.error(error);
        growlStore.showError('Error occurred while trying to submit schedule');
        sendMetric('scheduling.UnknownError', 'scheduling', {
          status: 'error'
        });
      } finally {
        return eplModel.get().then(() => {
          dispatch({
            type: 'UPDATE',
            payload: {
              renderSpinner: false
            }
          });
          handleClose();
        });
      } // Meeting Type none and mckinsey ends

    } // When it's calendarview


    if (currentPath === 'calendarview') {
      dispatch({
        type: 'UPDATE',
        payload: {
          renderSpinner: true
        }
      });

      if (multipleExperts) {
        try {
          await updateScheduleAndNotifyForMultipleExpert();
          sendMetric('scheduling.MultipleExpertMeeting.reschedule', 'MEM', {
            status: 'success'
          });
          return handleClose();
        } catch (error) {
          sendMetric('scheduling.MultipleExpertMeeting.reschedule', 'MEM', {
            status: 'fail'
          });
          throw error;
        }
      }

      growlStore.showSuccess('Updating schedule...');
      const timezone = availabilityStore.staticData.names.timezones[availabilityStore.epl.expert.address.timezoneId];
      const scheduleStartTime = moment(getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration).time.start);
      scheduleStartTime.tz(timezone);
      const scheduleEndTime = moment(getNewTimeSlot(new Date(dayToRender.startOf('day')), opsTime, duration).time.start);
      scheduleEndTime.tz(timezone);

      if (expertInvited && !availabilityStore.schedule.zoomMeetingId) {
        await updateZoomMeeting(availabilityStore, null);
        await availabilityStore.init();
      }

      await updateExpertMessage(newSchedule);
      const data = await getSubmittedSchedule({
        newSchedule,
        newTimeSlots: null
      });
      growlStore.showSuccess('Schedule Updated');

      if (availabilityStore.schedule !== null) {
        sendMetric('scheduling.meetingRescheduled', 'scheduling', {
          version: 'new'
        });
      } else {
        sendMetric('scheduling.meetingScheduled', 'scheduling', {
          version: 'new'
        });
      }

      const client = quickUpdateClient || clientinviteEdited === 'client' && !clientInvited || clientsAdded;
      const expert = (quickUpdateExpert || expertinviteEdited === 'expert') && !expertInvited || expertAdditionalsAdded;
      await closingActions(client, expert, data); // Actions for calendarview ends

      return;
    } // If there are multiple experts added


    if (!!expertsAdded.length) {
      try {
        await handleExpertsAdded();
        sendMetric('scheduling.MultipleExpertMeeting.expertsAdded', 'MEM', {
          status: 'success'
        });
        return;
      } catch (error) {
        sendMetric('scheduling.MultipleExpertMeeting.expertsAdded', 'MEM', {
          status: 'fail'
        });
        throw error;
      }
    }

    if (!isSlotAvailable()) return;

    if (schedule.timeslots.length) {
      dispatch({
        type: 'UPDATE',
        payload: {
          renderSpinner: true
        }
      });
      growlStore.showSuccess('Updating schedule...');
      const data = await getSubmittedSchedule({
        newSchedule,
        newTimeSlots: null
      });
      growlStore.showSuccess('Schedule Updated');
      const client = quickUpdateClient || clientinviteEdited === 'client' && !clientInvited || clientsAdded;
      const expert = quickUpdateExpert || expertinviteEdited === 'expert' && !expertInvited || expertAdditionalsAdded;
      await closingActions(client, expert, data);
      return;
    }

    if (submitFirstMatch) {
      dispatch({
        type: 'UPDATE',
        payload: {
          renderSpinner: true
        }
      });
      const multiplier = availabilityStore.schedule && availabilityStore.schedule.duration || 60;
      growlStore.showSuccess('Updating schedule...');
      const newTimeslots = [{
        duration: multiplier,
        id: uuid(),
        time: {
          start: firstMatch,
          end: firstMatch + (1000 * 60 * availabilityStore.schedule && !!availabilityStore.schedule.duration ? availabilityStore.schedule.duration : 60)
        },
        drafts: []
      }];
      await getSubmittedSchedule({
        newSchedule,
        newTimeSlots: newTimeslots
      });
      growlStore.showSuccess('Schedule Updated');

      if (availabilityStore.schedule !== null) {
        sendMetric('scheduling.meetingRescheduled', 'scheduling', {
          version: 'new'
        });
      } else {
        sendMetric('scheduling.meetingScheduled', 'scheduling', {
          version: 'new'
        });
      }

      return eplModel.get().then(() => handleClose());
    }

    eplModel.get().then(() => handleClose());
  };
  /*
  Logic flow of confirmPress in plain English
  1. Data Validation
  2. If it is availability view, update availabilities
  3. If is mckinsey project, send project data to capi, if failed, exit
  4. If meeting type is none or mckinsey, submit schedule and notify, exit
  5. If it's calendar, update schedule and notify
  6. If experts are added, update zoom and invite client and experts
  7. Check if timeslot is available
  8. If schedule exist, submit schedule
  9. If submitFirstMatch is true, submit schedule
  */


  const confirmPress = async () => {
    setIsSubmitting(true); // When data is not valid, don't go further

    if (dataIsNotValid()) return;

    try {
      await executeActions();
    } catch (error) {
      console.error(error);
      growlStore.showError('Error Occurred while Submitting Schedule');
    }

    setIsSubmitting(false);
  };

  function getConfirmButtonText(expertsAdded, readOnly) {
    if (expertsAdded.length) {
      return `Confirm ${expertsAdded.length} expert${expertsAdded.length > 1 ? 's' : ''}`;
    }

    return readOnly ? 'Confirm Slot' : 'Confirm';
  }

  function renderOverview() {
    dispatch({
      type: 'UPDATE',
      payload: {
        currentPath: 'overview'
      }
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__controls"
  }, /*#__PURE__*/React.createElement("div", {
    className: "request-schedule__controls--left"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button button--primary",
    onClick: confirmPress,
    disabled: availabilityStore.submitting || isSubmitting
  }, getConfirmButtonText(expertsAdded, readOnly)), currentPath === 'calendarview' && /*#__PURE__*/React.createElement("button", {
    className: "button button--secondary",
    onClick: renderOverview
  }, "Back")), /*#__PURE__*/React.createElement("button", {
    className: "button button--secondary",
    onClick: () => handleClose()
  }, "Close"));
};

export default Submit;